export function AssignedBodyCell() {
  return null;
}
